var _excluded = ["children", "className", "collapsed", "onToggle", "panelKey"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useState } from "react";
import AAccordionContext from "./AAccordionContext";
import AAccordionPanelContext from "./AAccordionPanelContext";
import "./AAccordion.scss";
var accordionPanelCounter = 1;
var AAccordionPanel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    _ref$collapsed = _ref.collapsed,
    collapsed = _ref$collapsed === void 0 ? true : _ref$collapsed,
    onToggle = _ref.onToggle,
    panelKey = _ref.panelKey,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBody = _useState2[0],
    setHasBody = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    panelId = _useState4[0],
    setPanelId = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFocused = _useState6[0],
    setIsFocused = _useState6[1];
  var _useContext = useContext(AAccordionContext),
    openedPanels = _useContext.openedPanels,
    setOpenedPanels = _useContext.setOpenedPanels;
  useEffect(function () {
    if (panelKey) return;
    if (!panelId) {
      var index = accordionPanelCounter++;
      setPanelId(index);
      if (!collapsed) setOpenedPanels(function (existing) {
        return [].concat(_toConsumableArray(existing), [index]);
      });
    }
  }, [panelId, collapsed, setOpenedPanels, panelKey]);
  var isCollapsed = panelKey ? collapsed : !openedPanels.includes(panelId);
  var className = "a-accordion__card";
  if (isCollapsed) {
    className += " a-accordion__card--state-collapsed";
  }
  if (isFocused) {
    className += " a-accordion__card--is-focused";
  }
  if (hasBody) {
    className += " a-accordion__card--has-body";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var accordionPanelContext = {
    panelId: panelId,
    setIsFocused: setIsFocused,
    hasBody: hasBody,
    setHasBody: setHasBody,
    panelKey: panelKey,
    isCollapsed: isCollapsed,
    onToggle: onToggle
  };
  var props = {};
  if (hasBody) {
    props["aria-expanded"] = !isCollapsed;
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, props, {
    className: className,
    ref: ref
  }), /*#__PURE__*/React.createElement(AAccordionPanelContext.Provider, {
    value: accordionPanelContext
  }, children));
});
AAccordionPanel.propTypes = {
  /**
   * Sets the default collapsed state.
   */
  collapsed: PropTypes.bool,
  /**
   *
   */
  panelKey: PropTypes.string,
  /**
   * Handles the expand/collapse toggle event.
   */
  onToggle: PropTypes.func
};
AAccordionPanel.displayName = "AAccordionPanel";
export default AAccordionPanel;